module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Black.225fa9b.woff";